import { EVENT_CLOSE_WITHDRAW, EVENT_OPEN_WITHDRAW } from "@components/utils/WithdrawDrawer";

export function openWithdraw() {
  window.dispatchEvent(new CustomEvent(EVENT_OPEN_WITHDRAW));
}
export function closeWithdraw() {
  window.dispatchEvent(new CustomEvent(EVENT_CLOSE_WITHDRAW));
}
